import { Card } from "./useCards";

interface CardBackend {
  cardId: string;
  timestamp?: number;
  source?: string;
  id?: string;
  expirationIsoDate: string;
  state: CardState;
  stateHistory?: StateHistory[];
  topUpsHistory?: any[];
  accumulatedFlexHistory?: any[];
  fundsByCategory?: FundsByCategory;
  creationTimestamp?: any;
  requestTimestamp: number;
  activatedTimestamp?: any;
  lockedFlex?: LockedFlex;
  accumulatedFlexAllowed?: AccumulatedFlexAllowed;
  accumulatedFlexByCategory?: AccumulatedFlexByCategory;
  tag?: string;
  categoryType: CardCategory;
  bin?: number;
  cardIdHistory?: CardIdHistory[];
  type: CardType;
  requestUpdate?: boolean;
  employeeId?: string;
  companyId?: string;
}

interface StateHistory {
  state: CardState;
  timestamp: number;
}

interface FundsByCategory {
  "meal-benefit": Amount;
  "transport-benefit": Amount;
  "nursery-benefit": Amount;
  "education-benefit": Amount;
  "health-insurance-benefit": Amount;
  "renting-benefit": Amount;
  "life-insurance-benefit": Amount;
  "gym-benefit": Amount;
  "it-product-benefit": Amount;
  "groceries-benefit": Amount;
  "gas-benefit": Amount;
  "restaurants-benefit": Amount;
  "home-office-benefit": Amount;
}

interface Amount {
  amountInCents: number;
  currency: string;
}

interface LockedFlex {
  "meal-benefit": boolean;
  "transport-benefit": boolean;
}

interface AccumulatedFlexAllowed {
  "meal-benefit": boolean;
  "transport-benefit": boolean;
}

interface AccumulatedFlexByCategory {
  "meal-benefit": Amount;
  "transport-benefit": Amount;
  "nursery-benefit": Amount;
  "education-benefit": Amount;
  "health-insurance-benefit": Amount;
  "renting-benefit": Amount;
  "life-insurance-benefit": Amount;
  "gym-benefit": Amount;
  "it-product-benefit": Amount;
  "groceries-benefit": Amount;
  "gas-benefit": Amount;
  "restaurants-benefit": Amount;
  "home-office-benefit": Amount;
}

interface CardIdHistory {
  id: string;
  cardId: string;
  timestamp: number;
  source: string;
}
enum CardState {
  CANCELLED = "cancelled",
  SENT = "sent",
  DEACTIVATED = "deactivated",
  ACTIVE = "active",
  BLOCKED = "blocked",
  PENDING = "pending",
}
enum CardType {
  VIRTUAL = "virtual",
  PHYSICAL = "physical",
}

enum CardCategory {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  REPLACEMENT = "replacement",
  DISUSE = "disuse",
}

const restoreCards = (cards: CardBackend[]): Card[] => {
  return cards.map((card) => ({
    cardId: card.cardId,
    requestUpdate: card.requestUpdate,
    type: card.type,
    state: card.state,
    categoryType: card.categoryType,
    requestTimestamp: card.requestTimestamp,
    activatedTimestamp: card.activatedTimestamp,
    isVirtual: card.type === CardType.VIRTUAL,
    isPhysical: card.type === CardType.PHYSICAL,
    isCancelled: card.state === CardState.CANCELLED,
    expirationIsoDate: card.expirationIsoDate,
  }));
};

export { restoreCards };
